export default {
	name: 'subjectFeedback',
	data() {
		return {
			Shop: this.$store.state.shop.filter(x => x.areaID == this.areaID),
			ShopID: this.$store.state.user.ShopID,
			selectShopID: this.$store.state.user.ShopID,
			areaID: this.$store.state.user.areaID,
			users: [],
			ShopSubjects: [],
			getData: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0,
			searchText: '',
		};
	},
	created() {
		this.searchText = new Date().getFullYear() + '-' + (new Date().getMonth() + 101).toString().substr(1) + '-' + (
			new Date().getDate() + 100).toString().substr(1);
		this.areaID = this.$store.state.user.areaID;
		this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
		this.getData = () => {
			this.$request.request({
				url: 'Shops/getShopSubjects',
				data: {
					ShopID: this.selectShopID,
					searchText: this.searchText,
					pageIndex: this.pageIndex,
					pageCount: this.pageRows
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.ShopSubjects = r.ShopSubjects;
					this.count = r.count;
				}
			});
		}
	},
	methods: {
		selectArea() {
			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.count = 0;
			this.books = [];

			if (this.Shop.length > 0) {
				this.selectShopID = this.Shop[0].ShopID;
				this.pageIndex = 1;
				this.getData();
			}
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;
			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}
			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkCustomer() {
			return this.$uil.checkPhone(this.CustomerPhone) && this.$uil.checkchinese(this.CustomerName, 2, 6);
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		},
		checkFile() {
			if (this.fileName == '') return '请选择图片';
			let index = this.fileName.lastIndexOf('.');
			if (index == -1) return '格式错误';
			let ext = this.fileName.substring(index + 1);
			if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) == -1)
				return '格式错误';
			else
				return '';
		}
	},
	filters: {
		rmb(v) {
			return v + '¥';
		}
	},
	activated() {
		this.getData();
	}
}
